import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const MyOrdersTableMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/MyOrdersTableMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/MyOrdersTableWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
 return component ? (
  <LoadedComponent {...props} mode={mobileMode} />
   ) : (
  <></> 
  );
};

export default MyOrdersTableMain;
